import { Coordinate } from 'ol/coordinate';
import Point from 'ol/geom/Point';
import { Subscription } from 'rxjs';
import { BufferOp } from 'jsts/org/locationtech/jts/operation/buffer.js';
import { FilterConfig } from '../datasets/filter';
import { MapConfig } from '../datasets/map-config';
import { MINQUARTER } from 'src/assets/constants/constants';

export function unsubscribe(subscription: Subscription | Subscription[]) {
    const subscriptions = Array.isArray(subscription) ? subscription : [subscription];
    subscriptions.forEach((s) => {
        if (s && !s.closed) {
            s.unsubscribe();
        }
    });
}

export function localeToLang(locale: string): string {
    return locale.split('-')[0];
}

export function isNullOrUndefined(val) {
    return val === null || val === undefined;
}

export function isNullOrUndefinedOrEmpty(val) {
    return val == null || val == undefined || val == '';
}

export function formatYearQuarter(label: number): string {
    const quarters = ['Q01', 'Q02', 'Q03', 'Q04'];
    const result = Math.floor(label) + quarters[(label % 1) / 0.25];
    return result;
}

export function reFormatYearQuarter(label: string): number {
    const quarters = ['.0', '.25', '.50', '.75'];
    const quarter = label.split('Q0');
    const result = quarter[0] + quarters[Number(quarter[1]) - 1];
    return Number(result);
}

export function getCurrentYearQuarter(): number {
    return new Date().getFullYear() + Math.floor(new Date().getMonth() / 3) * 0.25;
}

export function getCurrentYearQuarterPostfix(): string {
    return formatYearQuarter(getCurrentYearQuarter());
}

export function getCurrentYearQuartersPostfixes(): string[] {
    const quarters = [];
    const upVal = 0.25;
    let quarter = MINQUARTER;
    while (quarter <= getCurrentYearQuarter()) {
        quarters.push(formatYearQuarter(quarter));
        quarter += upVal;
    }
    return quarters;
}
export function setBackgroudTable(value: string): string {
    if (value === '0 - 1 Mbps') {
        return '#ff1400';
    }
    else if (value === '1 - 10 Mbps') {
        return '#ff1400';
    }
    else if (value === '10 - 30 Mbps') {
        return '#fe6131';
    }
    else if (value === '30 - 50 Mbps') {
        return '#fdae61';
    }
    else if (value === '50 - 100 Mbps') {
        return '#fed790';
    }
    else if (value === '100 - 150 Mbps') {
        return '#ffffbf';
    }
    else if (value === '100 - 350 Mbps') {
        return '#ffffbf';
    }
    else if (value === '350 - 400 Mbps') {
        return '#d5eeb2';
    }
    else if (value === '350+ Mbps') {
        return '#d5eeb2';
    }
    else if (value === '350 - 1000 Mbps') {
        return '#d5eeb2';
    }
    else if (value === '1000+ Mbps') {
        return '#abdda4';
    }
    else if (value === '1000 - 2500 Mbps') {
        return '#abdda4';
    }
    else if (value === '8500 - 10000 Mbps' || value === '5000 - 8500 Mbps') {
        return '#5dee52';
    }
    else if (value === '10000+ Mbps') {
        return '#0fff00';
    }
    else{
      return '#d3d3d3';
    }
}
export function setTextColor(value: string): string {
    if (value === '50 - 100 Mbps') {
        return 'black';
    }
    if (!value.includes('Mbps')) {
        return 'black';
    }
    if (value.includes('Mbps')) {
        return 'black';
    }
    return 'white';
}
export function setBuffer(coordinate: Coordinate, parser: any) {
    const point = new Point(coordinate).transform('EPSG:31370', 'EPSG:3857');
    const jstsGeom = parser.read(point);
    const bufferOp = new BufferOp(jstsGeom);
    const buffered = bufferOp.getResultGeometry(250);
    return parser.write(buffered);
}
export function checkCorrectParams(mapfilters: FilterConfig[], mapConfig: MapConfig, filterArr: string[]) {
    const isAllParamsCorrect = filterArr.map((fa) => {
        let isHave = false;
        mapfilters.forEach((fl) => {
            if (fl.choices.some((ch) => ch.value == mapConfig[fa])) {
                isHave = true;
            }
        });
        return isHave;
    });
    return isAllParamsCorrect;
}
export function checkQueryParameters(mapConfig: MapConfig, filterArr: string[]) {
    let isHave = true;
    filterArr.forEach((fa) => {
        if (!mapConfig[fa]) {
            isHave = false;
        }
    });
    return isHave;
}
